export const base64toFile = (
  base64: string,
  fileName = 'untitled',
  mime = ''
): File => {
  const arr = base64.split(',');
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  mime = mime ? mime : arr[0].match(/:(.*?);/)[1];

  return new File([u8arr], fileName, { type: mime });
};
export const getFileName = (path = ''): string => {
  return path.split(/[\\/]/).pop() || '';
};

export const getDropzoneAcceptedFormats = (
  supportedFileFormats: string[],
  mimePrefix: 'image' | 'video' | 'audio'
) =>
  supportedFileFormats.reduce((accumulator, supportedFileFormat) => {
    const formatLowerCase = supportedFileFormat.toLowerCase();

    return {
      ...accumulator,
      [`${mimePrefix}/${formatLowerCase}`]: [],
    };
  }, {});
